import { render } from "./ChatRoomModal.vue?vue&type=template&id=5037ae5a&ts=true"
import script from "./ChatRoomModal.vue?vue&type=script&lang=ts"
export * from "./ChatRoomModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__